export type EligibilityAnswer = 'yes' | 'no' | 'unknown'

export type EligibilityKey = 'residency' | 'age' | 'transport' | 'duplicate'

export interface EligibilityQuestion {
  key: EligibilityKey
  title: string
  help: string
}

export type EligibilityAnswers = Partial<Record<EligibilityKey, EligibilityAnswer>>

export const eligibilityQuestions: EligibilityQuestion[] = [
  {
    key: 'residency',
    title: '신청일 기준 경기도에 거주하고 있나요?',
    help: '주민등록상 경기도 거주 여부를 기준으로 확인해 주세요.',
  },
  {
    key: 'age',
    title: '지원받을 자녀가 만 6~18세인가요?',
    help: '정확한 연령 기준일은 공식 신청 안내에서 다시 확인해 주세요.',
  },
  {
    key: 'transport',
    title: '교통카드로 수도권 대중교통을 이용했나요?',
    help: '교통카드 태깅 기록이 있는 이용 내역을 기준으로 합니다.',
  },
  {
    key: 'duplicate',
    title: '같은 분기에 다른 교통비 지원을 받았나요?',
    help: '중앙부처 또는 지방자치단체 지원과 중복이 제한될 수 있습니다.',
  },
]

export interface EligibilityResult {
  kind: 'likely' | 'check'
  title: string
  message: string
}

export function evaluateEligibility(answers: EligibilityAnswers): EligibilityResult {
  const required = [answers.residency, answers.age, answers.transport]
  const allRequiredYes = required.every((answer) => answer === 'yes')
  const hasRequiredNo = required.some((answer) => answer === 'no')
  const hasUnknown = required.some((answer) => !answer || answer === 'unknown')

  if (allRequiredYes && answers.duplicate === 'no') {
    return {
      kind: 'likely',
      title: '지원 가능성이 있습니다',
      message: '신청 일정과 준비 항목을 확인한 뒤 공식 사이트에서 최종 자격을 확인해 주세요.',
    }
  }

  if (hasRequiredNo) {
    return {
      kind: 'check',
      title: '공식 사이트에서 추가 확인이 필요합니다',
      message: '현재 답변만으로는 기본 조건과 다른 부분이 있습니다. 예외나 정확한 기준은 공식 안내를 확인해 주세요.',
    }
  }

  if (answers.duplicate === 'yes') {
    return {
      kind: 'check',
      title: '중복 지원 여부를 확인해 주세요',
      message: '다른 교통비 지원을 받은 경우 중복 지급이 제한되거나 환수될 수 있습니다.',
    }
  }

  if (hasUnknown || answers.duplicate === 'unknown' || !answers.duplicate) {
    return {
      kind: 'check',
      title: '공식 사이트에서 추가 확인이 필요합니다',
      message: '확실하지 않은 항목이 있습니다. 신청 전에 공식 안내에서 조건을 확인해 주세요.',
    }
  }

  return {
    kind: 'check',
    title: '공식 사이트에서 추가 확인이 필요합니다',
    message: '지원 자격은 공식 사이트의 심사 결과로 최종 결정됩니다.',
  }
}

